'use strict';

angular.module('oddSurveyModule', [
]);